{
  "nav_zuerich": "Zürich",
  "nav_rapperswil": "Rapperswil & Zürichsee",
  "nav_einsiedeln": "Einsiedeln & Ybrig",
  "l_opening_hours": "Öffungszeiten",
  "l_contact": "Kontakt",
  "l_prices": "Preise",
  "Monday": "Montag",
  "Tuesday": "Dienstag",
  "Wednesday": "Mittwoch",
  "Thursday": "Donnerstag",
  "Friday": "Freitag",
  "Saturday": "Samstag",
  "Sunday": "Sonntag",
  "l_address": "Adresse",
  "l_email": "Email",
  "l_telephone": "Telefon",
  "l_homepage": "Homepage",
  "l_place": "Ort",
  "l_route": "Route",
  "l_change_map_style": "Karte wechseln",
  "l_filter_categories": "Kategorien filtern",
  "l_to_overview": "Zur Übersicht",
  "txt_intro_h": "Entdecken, essen, trinken, schlafen, feiern und entspannen in Zürich und Umgebung",
  "txt_intro_1": "Entdecke Zürich und Umgebung neu! Ob Einheimischer oder Tourist, hier findest du nützliche Infos, wo man gut isst, trinkt, schläft, feiert und sich entspannt. Tauche ein in die Vielfalt unserer Region.",
  "txt_intro_2_zuerich": "Zürich, die pulsierende Wirtschafts- und Kulturmetropole der Schweiz, bietet eine einzigartige Mischung aus Tradition und Moderne. Entdecke die charmanten Gassen der Altstadt, die lebhafte Bahnhofstrasse, den Zürichsee und die zahlreichen Museen und Theater.",
  "txt_intro_2_rapperswil": "Rapperswil am Zürichsee ist ein malerischer Ort mit einer historischen Altstadt, einem schönen Schloss und einer beeindruckenden Rosenanlage. Von hier aus können Sie den Zürichsee erkunden, die umliegenden Berge bewundern und die Ruhe der Natur geniessen.",
  "txt_intro_2_eyz": "Einsiedeln ist ein berühmter Wallfahrtsort mit einer beeindruckenden Klosteranlage. Ybrig ist eine Region mit zahlreichen Wanderwegen und Möglichkeiten für Wintersport. Hier findest du Ruhe und Erholung inmitten der beeindruckenden Schweizer Alpen."
}